import { createWebHistory, createRouter } from "vue-router";
import mushroom from "cem-probe-api";

import routes from "./routes";
import appConfig from "../../app.config";
import { isHaveDataDashboard } from "/src/stores/HaveDataDashboard";
import { timeRange } from "/src/stores/timeRange";
import { redirectToPrimaryLogin } from "@/utils/systemType";
import { abortAPI } from "/src/stores/abortAPI";
const router = createRouter({
  history: createWebHistory(),
  routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  },
});
const updateStoreTimeRange = async (name, id, path) => {
  const storeTimeRange = timeRange();
  let type = "static";
  if (name === "DichVu") type = "service";
  if (name === "TableScreen") type = "table_screen";
  if (name === "Dynamic") type = "dynamic";
  if (name && name.indexOf("Usecase") !== -1) type = "usecase";

  if (type !== "static" && !id) return;
  mushroom.time_range.invalidCache();
  try {
    const response = await mushroom.time_range.listAsync(
      {
        filters:
          type === "static"
            ? ["target_type=static", "link=" + path]
            : ["target_type=" + type, "target_id=" + id],
        limit: 1,
      },
    );
    if (response.result?.length === 0) {
      const timeRangeSystemConfig = await mushroom.system_config.listAsync({
        filters: ["key=time_range"],
        limit: 1,
      });
      if (timeRangeSystemConfig.result?.length > 0) {
        storeTimeRange.setTimeRange(
          Number(timeRangeSystemConfig.result[0]?.value) || 0,
        );
      }
    } else {
      storeTimeRange.setTimeRange(Number(response.result[0]?.day_limit) || 0);
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
  }
};
// location.replace("/")
// const storeTimeRange = timeRange();
router.beforeEach(async function (to, from, next) {
  const storeIsHaveDataDashboard = isHaveDataDashboard();
  const storeAbortAPI = abortAPI();
  // storeAbortAPI.deleteAbort();

  if (
    from.params.id !== to.params.id ||
    from.query.id !== to.query.id
  ) {
    updateStoreTimeRange(to.name, to.params.id || to.query.id, to.path);
  }

  if (from.name != to.name) {
  storeAbortAPI.deleteAbort();

    if (to.meta.page && to.meta.page == "admin") {
      localStorage.setItem("urlOld", from.fullPath);
      // lưu đường dẫn link web hiện tại vào stograte để sau login lại

      try {
        const userResponse = await mushroom.$auth.meAsync();
        if (userResponse)
          localStorage.setItem("userInfo", JSON.stringify(userResponse));
      } catch (error) {
        redirectToPrimaryLogin(to.fullPath);
        return;
      }

      next();
      updateStoreTimeRange(to.name, to.params.id, to.path);
      clearTimeout(window.checkStatusDownloadProbe); // xoá check download dashboard
      storeIsHaveDataDashboard.noData();
    } else if (to.meta.page && to.meta.page != "admin") {
      next();
      updateStoreTimeRange(to.name, to.params.id || to.query.id, to.path);
    } else {
      console.log('về trang /error case 1: ', { 'from': from, 'to': to })
      next("/error");
    }
  } else if (from.name && to.name && from.name == to.name) {
    next();
  } else {
    if (!to.name) {
      console.log('về trang /error case 2: ', { 'from': from, 'to': to })
      next("/error");
    } else {
      redirectToPrimaryLogin(to.fullPath);
    }
  }
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
  try {
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            if (args.length) {
              next(...args);
              reject(new Error("Redirected"));
            } else {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
    }
  } catch (error) {
    return;
  }
  document.title = routeTo.meta.title + " | " + appConfig.title;
  next();
});

export default router;
